export default __webpack_public_path__ + "static/media/eurFlag.d41980f1.svg";